import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { UntypedFormControl } from '@angular/forms'
import { MomentDateAdapter } from '@angular/material-moment-adapter'
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core'
import { MatPaginator } from '@angular/material/paginator'
import { MatTableDataSource } from '@angular/material/table'
import { ActivatedRoute, Router } from '@angular/router'
import * as moment from 'moment'
import { Subscription } from 'rxjs'
import { debounceTime } from 'rxjs/operators'
import { Client } from '../shared/client/client'
import { ClientService } from '../shared/client/client.service'
import { CUSTOM_DATE_FORMAT } from '../shared/datepicker/datepicker-format'
import { SideBarComponent } from '../shared/sidebar/side-bar-component'
import { SideBarService } from '../shared/sidebar/side-bar.service'
import { Order } from './shared/order'
import { OrderService } from './shared/order.service'

@Component({
  selector: 'app-order-tracking',
  templateUrl: './order-tracking.component.html',
  styleUrls: ['./order-tracking.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE], },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMAT },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' }
  ],
})
export class OrderTrackingComponent extends SideBarComponent implements OnInit, OnDestroy {

  dataSource: MatTableDataSource<Order>
  dataRes: MatTableDataSource<Order>
  searchControl: UntypedFormControl = new UntypedFormControl('')
  searchDateBeginControl: UntypedFormControl = new UntypedFormControl('')
  searchDateEndControl: UntypedFormControl = new UntypedFormControl('')
  searchStatuControl: UntypedFormControl = new UntypedFormControl([])
  searchTypeControl: UntypedFormControl = new UntypedFormControl([])
  statutList = ['Emis', 'Traitée', 'Prise en compte', 'En cours de traitement']
  typeList = ['Gestion au quotidien', 'Réclamation', 'Autre demande']

  select: string = "c"
  active: string = ""

  // Colonnes
  columns = [
    { id: 'status', path: ['statut', 'libelle'], libelle: 'Statut' },
    { id: 'numdemande', libelle: 'N°' },
    { id: 'date_demandeM', libelle: 'Date' },
    { id: 'nom_demandeur', libelle: 'Demandeur' },
    { id: 'type', libelle: 'Type de demande' },
    { id: 'utilisateur', libelle: 'Utilisateur' },
    { id: 'titre', libelle: 'Motif' },
    { id: 'service', path: ['service_destinataire', 'libelle'], libelle: 'Service Destinataire' }
  ]
  displayedColumns: string[] = ['status', 'numdemande', 'date_demandeM', 'nom_demandeur', 'type', 'utilisateur', 'titre', 'service', 'actions']
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator
  currentClient: Client = null
  // Subscribe pour onLoad
  sub: Subscription = new Subscription()
  searchText: string = ''
  load: boolean = true
  filterValues = { userTitle: '', type: '', date_demandeM: '', status: '' }
  subClient: Subscription
  sousComptes: boolean = false

  /**
   *
   * @param {OrderService} orderTrackingService
   * @param {Router} router
   * @param {SideBarService} sideBar
   * @param route
   * @param clientService
   */
  constructor(
    protected orderTrackingService: OrderService,
    protected router: Router,
    protected sideBar: SideBarService,
    protected route: ActivatedRoute,
    protected clientService: ClientService
  ) {
    super(
      sideBar,
      router,
      route
    )
  }

  private demandeFilter(userTitleNum: string, dateDebut: moment.Moment, dateFin: moment.Moment, statuts: string[], types: string[]): void {
    this.dataRes.data = this.dataSource.data.filter((order: Order, index: number, orders: Order[]) => {
      const predicate = ['titre', 'utilisateur', 'numdemande']
      return predicate.some(key => {
        let search: string = ''
        if (order[key] == undefined) {
          return false
        } else {
          search = order[key].toString()
        }
        if (userTitleNum.length !== 0) {
          return search.toUpperCase().includes(userTitleNum.trim().toUpperCase())
        } else {
          return true
        }
      })
    }).filter((order: Order, index: number, orders: Order[]) => {
      if (moment.isMoment(dateDebut)) {
        return order.date_demandeM >= dateDebut
      } else {
        return true
      }
    }).filter((order: Order, index: number, orders: Order[]) => {
      if (moment.isMoment(dateFin)) {
        return order.date_demandeM.set({ hour: 0, minute: 0, second: 0, millisecond: 0 }) <= dateFin
      } else {
        return true
      }
    }).filter((order: Order, index: number, orders: Order[]) => {
      if (statuts.length !== 0) {
        return statuts.some(statut => {
          return order.statut.libelle.toUpperCase().includes(statut.trim().toUpperCase())
        })
      } else {
        return true
      }
    }).filter((order: Order, index: number, orders: Order[]) => {
      if (types.length !== 0) {
        return types.some(type => {
          return order.type != null && order.type.toUpperCase().includes(type.trim().toUpperCase())
        })
      } else {
        return true
      }
    })
  }

  ngOnInit(): void {
    super.ngOnInit()
    this.dataSource = new MatTableDataSource<Order>()
    this.dataRes = new MatTableDataSource<Order>()
    this.dataSource.data = []
    this.dataRes.data = []

    this.searchControl.valueChanges.pipe(debounceTime(300)).subscribe(userTitleNumSearchValue => {
      this.demandeFilter(userTitleNumSearchValue, this.searchDateBeginControl.value, this.searchDateEndControl.value,
        this.searchStatuControl.value, this.searchTypeControl.value)
    })
    this.searchDateBeginControl.valueChanges.pipe(debounceTime(300)).subscribe(dateSearchBeginValue => {
      this.demandeFilter(this.searchControl.value, dateSearchBeginValue, this.searchDateEndControl.value, this.searchStatuControl.value, this.searchTypeControl.value)
    })
    this.searchDateEndControl.valueChanges.pipe(debounceTime(300)).subscribe(dateSearchValue => {
      this.demandeFilter(this.searchControl.value, this.searchDateBeginControl.value, dateSearchValue, this.searchStatuControl.value, this.searchTypeControl.value)
    })
    this.searchStatuControl.valueChanges.pipe(debounceTime(300)).subscribe(value => {
      this.demandeFilter(this.searchControl.value, this.searchDateBeginControl.value, this.searchDateEndControl.value, value, this.searchTypeControl.value)
    })
    this.searchTypeControl.valueChanges.pipe(debounceTime(300)).subscribe(value => {
      this.demandeFilter(this.searchControl.value, this.searchDateBeginControl.value, this.searchDateEndControl.value, this.searchStatuControl.value, value)
    })

    this.subClient = this.clientService.getCurrentClient().subscribe(client => {
      this.currentClient = client;
      this.getTrackingList()
    })
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe()
    if (this.subClient) {
      this.subClient.unsubscribe()
    }
  }

  /**
   *
   * @param client
   */
  getTrackingList(): void {
    this.sub.unsubscribe()
    this.sub = this.orderTrackingService.getTrackingList(this.currentClient, this.sousComptes).subscribe(orders => {
      this.dataSource.data = orders.sort((a, b) => a.date_demande > b.date_demande ? -1 : 1)
      this.load = false
      this.dataRes.data = this.dataSource.data
      this.paginator._intl.itemsPerPageLabel = 'Demandes par page '
      this.dataRes.paginator = this.paginator
      this.dataRes.data.forEach(data => {
        if (data['id_porteur']) {
          data['utilisateur'] = data['id_porteur'] + " : " + data['nom_prenom_porteur']
        } else {
          data['utilisateur'] = data['nom_prenom_porteur']
        }
        if (!data['type'] || data['type'] == 'Nous Contacter') {
          data['type'] = 'Autre demande'
        }
      })
      this.demandeFilter(this.searchControl.value, this.searchDateBeginControl.value, this.searchDateEndControl.value,
        this.searchStatuControl.value, this.searchTypeControl.value)
    })
  }

  /**
   *
   * @param row
   * @returns {Promise<void>}
   */
  orderDetails(order: Order) {
    let outlets = {}
    if (order.type === 'Réclamation') {
      outlets['sidebar'] = [order.numero, true]
    } else {
      outlets['sidebar'] = [order.numero, false]
    }
    this.router.navigate([{ outlets }], {
      relativeTo: this.route,
      skipLocationChange: true,
    }).then(() => this.sideBarService.open(), err => console.log(err))
  }

  export() {
    this.sub.unsubscribe()
    this.sub = this.orderTrackingService.exportOfCurrentDemandes(this.currentClient, this.searchControl.value, this.searchDateBeginControl.value, this.searchDateEndControl.value, this.searchStatuControl.value).subscribe()
  }

  getStatut(element) {
    return element.statut.statut
  }

  changeSousComptes($event) {
    this.sousComptes = $event.checked
    this.getTrackingList();
  }
}
